export const WINDOW_RESIZE = 'windowResize'



// WEBPACK FOOTER //
// ./src/components/Charts/EventKeys.js